import { render, staticRenderFns } from "./numericMarker.vue?vue&type=template&id=1b480c8b&"
import script from "./numericMarker.vue?vue&type=script&lang=js&"
export * from "./numericMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports